import React, { useEffect, useState } from 'react';
import './tasksInt.css';
import TaskCardInt from './TaskCard';
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import TaskCardCompletedInt from "./taskCardCompleted";
import {useHistory} from "react-router-dom";

function TasksInt(props) {
	const { data, bottomCard, campaignOrg, scrollNav, swipeActions } = props;
	const history = useHistory();
	return (
		<>
			<div className="page-content page-content-task" {...swipeActions}>
				<div className="task-page-header">
					<h2>Complete tasks and  earn points</h2>
					<p>You can earn points by doing some simple tasks and teaching your students</p>
				</div>
				<div className="task-page-cards">
					<TaskCardInt data={data} scrollNav={scrollNav} campaignOrg={campaignOrg}/>
				</div>
				<TaskCardCompletedInt data={data} scrollNav={scrollNav}
									  campaignOrg={campaignOrg}></TaskCardCompletedInt>
				
				{/* <div className="task-bottom-card">
					<h2>Earn more points <span>by completing below tasks</span></h2>
					<p>Each Task Contain 100 points </p>
					<BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt>
				</div> */}
			</div>
		</>
	);
}

export default TasksInt;
